import moment from "moment";
import {
  CONFIGURED_SERVICE_STATUS,
  serviceIds,
} from "../../modules/assessments/components/foundational-best-practices/constants";

var createdDate = moment();
createdDate = moment.utc(createdDate.subtract(2, "hours"));

export const getfbpManagementAccounts = () => {
  return [
    {
      AccountName: "Acme Inc Master AWS Account",
      AccountNumber: "181570489212",
      AccountStatus: "Connected",
      AccountType: "Management",
      CustomerAccountId: "ad9981cd-cc93-45c0-963b-c1598f9d16c4",
      FBPConfigured: true,
      LastScan: createdDate,
    },
  ];
};

const fbpManagementAccountDetails = [
  {
    AccountNumber: "181570489212",
    AccountType: "MANAGEMENT",
    Configuration: {
      ManagedAccounts: ["123456789012"],
      ManagedRegions: ["us-east-1", "us-east-2"],
    },
    ControlTowerAuditAccountNumber: "987654321098",
    ControlTowerHomeRegion: "us-east-1",
    ControlTowerLogAccountNumber: "562783538012",
    ControlTowerManagedAccounts: ["123456789012"],
    ControlTowerManagedRegions: ["us-east-1", "us-east-2"],
    ControlTowerStatus: "CONFIGURED",
    ControlTowerStatusUpdatedAt: "2023-06-12 12:01:35",
    CreatedAt: "2023-06-12 11:42:00",
    CreatedBy: "3b174837-d8ec-41c3-9334-662cdd5758dd",
    CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
    ErrorMessage: "",
    Id: "95d53186-a78f-45a5-8055-b1d44d36fdec",
    IsControlTowerAuditAccountOnboarded: true,
    IsControlTowerLogAccountOnboarded: true,
    OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
    ServiceCode: "ControlTower",
    ServiceScanStatus: "COMPLETED",
    UpdatedAt: "2023-06-12 12:01:35",
    UpdatedBy: "3b174837-d8ec-41c3-9334-662cdd5758dd",
  },
  {
    Configuration: {
      EnableEKSProtection: true,
      EnableLambdaProtection: true,
      EnableMalwareProtection: true,
      EnableRDSProtection: true,
      EnableS3Protection: true,
      FindingPublishingFrequency: "FIFTEEN_MINUTES",
    },
    CreatedAt: "2023-06-12 11:42:00",
    CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
    FBPWorkloadId: "95d53186-a78f-45a5-8055-b1d44d36fdec",
    Id: "66fccab6-369a-4817-90ab-1ff587fd659e",
    OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
    ServiceCheckFindings: {},
    ServiceCode: "GuardDuty",
    ServiceScanErrorMessage: "",
    ServiceScanRequestedBy: "3b174837-d8ec-41c3-9334-662cdd5758dd",
    ServiceScanStatus: "COMPLETED",
    ServiceStatus: "NOT_CONFIGURED",
    UpdatedAt: "2023-06-12 14:28:25",
  },
  {
    Configuration: {
      "AWSFoundationalSecurityBestPracticesv1.0": true,
      "CISAWSFoundationsBenchmarkv1.2": true,
      "CISAWSFoundationsBenchmarkv1.4": true,
      "NISTSpecialPublication800-53Revision5": true,
      "PCIDSSv3.2.1": true,
    },
    CreatedAt: "2023-06-12 11:42:00",
    CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
    FBPWorkloadId: "95d53186-a78f-45a5-8055-b1d44d36fdec",
    Id: "c27262aa-794f-4581-8e9b-964e2f0ea168",
    OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
    ServiceCheckFindings: {},
    ServiceCode: "SecurityHub",
    ServiceScanErrorMessage: "",
    ServiceScanRequestedBy: "3b174837-d8ec-41c3-9334-662cdd5758dd",
    ServiceScanStatus: "COMPLETED",
    ServiceStatus: "CONFIGURED",
    UpdatedAt: "2023-06-12 13:42:27",
  },
  {
    Configuration: {
      EnableLambdaEvents: false,
      EnableManagementEvents: true,
      EnableS3DataEvents: true,
    },
    CreatedAt: "2023-06-12 11:42:00",
    CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
    FBPWorkloadId: "95d53186-a78f-45a5-8055-b1d44d36fdec",
    Id: "e81758bc-54ab-4599-acce-d46b69e032e4",
    OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
    ServiceCheckFindings: [
      {
        CheckId: "CTRL-01",
        CheckName:
          "Ensure that an organization trail present in the management account?",
        Finding: "Organization CloudTrail is configured",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-02",
        CheckName:
          "Ensure that multi-region logging is enabled for organization-trail.",
        Finding: "Organization trail covers all regions",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-03",
        CheckName:
          "Ensure that a trail logging bucket is created in the log account",
        Finding:
          "Organization trail\u2019s log  bucket is residing in the Log account.",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-04",
        CheckName:
          "Ensure that a trail logging bucket is created in the ControlTower's home region",
        Finding: "Trail logging bucket resides in ControlTower home region",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-05",
        CheckName:
          "CloudTrail Logging bucket must be encrypted using a KMS key that resides in the Audit account",
        Finding:
          "Log bucket is encrypted using a KMS key that resides in the Audit account.",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-06",
        CheckName: "CloudTrail Logging bucket must have versioning enabled.",
        Finding: "Log bucket has versioning enabled",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-07",
        CheckName:
          "Log file validation must be enabled for the organization-trail",
        Finding: "Log file validation is enabled",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-08",
        CheckName: "Ensure that trail logging is not stopped",
        Finding: "CloudTrail logging is enabled",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-09",
        CheckName:
          "CloudWatch logging must be enabled for the organization-trail and the log-group should reside in trail home regionl",
        Finding: "CloudWatch logging is enabled",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-10",
        CheckName:
          "Ensure that CloudTrail log bucket have block all public access settings enabled",
        Finding: "cloudTrail log bucket is not public",
        Status: "Passed",
      },
      {
        CheckId: "CTRL-11",
        CheckName:
          "Ensure that bucket key is enabled on CloudTrail  Log bucket ",
        Finding: "cloudtrail log bucket key is enabled",
        Status: "Passed",
      },
    ],
    ServiceCode: "CloudTrail",
    ServiceScanErrorMessage: "",
    ServiceScanRequestedBy: "3b174837-d8ec-41c3-9334-662cdd5758dd",
    ServiceScanStatus: "COMPLETED",
    ServiceStatus: "CONFIGURED",
    UpdatedAt: "2023-06-12 14:34:39",
  },
];

export const getfbpManagementAccountDetails = () => {
  return fbpManagementAccountDetails;
};

export const getfbpAccountRegionDetails = () => {
  return [
    {
      AccountNumber: "562783538012",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "1ab2b77b-f730-4fb9-b61a-14330c0b6f65",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-1",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:23",
    },
    {
      AccountNumber: "987654321098",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "29afc948-d133-4a2c-ae36-3e7b91faf8e3",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-2",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-02",
          CheckName:
            "GuardDuty service must be enabled in the Audit account in all ControlTower managed regions",
          Finding: "GuardDuty is not enabled in Audit Account in regions",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-04",
          CheckName:
            "Auto-enable GuardDuty should be turned on in GuardDuty Admin account in all controltower managed regions.",
          Finding: "Auto-enable is not activated",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-05",
          CheckName:
            "Auto-enable GuardDuty should be set to All Accounts in all controltower managed regions in GuardDuty Admin account",
          Finding: "Auto-enable is not set to All-Accounts",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-06",
          CheckName:
            "GuardDuty findings export option should be enabled in each controltower managed regions in Audit account",
          Finding: "Guardduty finding export is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-08",
          CheckName:
            "Ensure that GuardDuty finding export bucket bucket is created in the log account",
          Finding: "Guardduty finding export bucket found in the log account",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-09",
          CheckName:
            "Ensure that GuardDuty findings export S3 bucket has versioning enabled",
          Finding: "not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-12",
          CheckName:
            "Ensure that GuardDuty export S3 bucket have block all public access settings enabled",
          Finding: "not public",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-11",
          CheckName: "Ensure that bucket key is enabled on GuardDuty export S3",
          Finding: "cloudtrail log bucket key is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-10",
          CheckName:
            "Ensure that GuardDuty export S3 bucket must be encrypted by KMS CMK from Audit account",
          Finding:
            "not encrypted using a KMS key that resides in the Audit account.",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:22",
    },
    {
      AccountNumber: "181570489212",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "3b8cc803-0cf1-4ebd-8084-8eeb3ba1e68b",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-1",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:24",
    },
    {
      AccountNumber: "181570489212",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "4f7b5f92-15ec-4871-a3dc-a30487b4131e",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-2",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:25",
    },
    {
      AccountNumber: "123456789012",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "8a482365-cffb-452e-be58-9cf602078d54",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-2",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-01",
          CheckName:
            "Administration of GuardDuty must be delegated to the Audit account for all of the Control Tower managed regions.",
          Finding: "Delegated Administrator access is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:20",
    },
    {
      AccountNumber: "987654321098",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "9fe9bf52-edd2-48d5-b78f-1e07b25334b2",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-1",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-02",
          CheckName:
            "GuardDuty service must be enabled in the Audit account in all ControlTower managed regions",
          Finding: "GuardDuty is not enabled in Audit Account in regions",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-04",
          CheckName:
            "Auto-enable GuardDuty should be turned on in GuardDuty Admin account in all controltower managed regions.",
          Finding: "Auto-enable is not activated",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-05",
          CheckName:
            "Auto-enable GuardDuty should be set to All Accounts in all controltower managed regions in GuardDuty Admin account",
          Finding: "Auto-enable is not set to All-Accounts",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-06",
          CheckName:
            "GuardDuty findings export option should be enabled in each controltower managed regions in Audit account",
          Finding: "Guardduty finding export is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-08",
          CheckName:
            "Ensure that GuardDuty finding export bucket bucket is created in the log account",
          Finding: "Guardduty finding export bucket found in the log account",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-09",
          CheckName:
            "Ensure that GuardDuty findings export S3 bucket has versioning enabled",
          Finding: "not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-12",
          CheckName:
            "Ensure that GuardDuty export S3 bucket have block all public access settings enabled",
          Finding: "not public",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-11",
          CheckName: "Ensure that bucket key is enabled on GuardDuty export S3",
          Finding: "cloudtrail log bucket key is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-10",
          CheckName:
            "Ensure that GuardDuty export S3 bucket must be encrypted by KMS CMK from Audit account",
          Finding:
            "not encrypted using a KMS key that resides in the Audit account.",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:21",
    },
    {
      AccountNumber: "562783538012",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "a2fdf5ac-f601-4468-9679-d2431e4636b4",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-2",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:23",
    },
    {
      AccountNumber: "123456789012",
      CreatedAt: "2023-06-12 13:36:20",
      CustomerId: "aa17fc31-921f-4a32-b15d-85e71f99f04a",
      FBPWorkloadServiceScanId: "66fccab6-369a-4817-90ab-1ff587fd659e",
      Id: "ed55fda4-1d6c-4e73-b2de-7452c9f9daba",
      OrganizationId: "4f6cb812-087b-48d8-932b-59c9431f7cf4",
      RegionCode: "us-east-1",
      ServiceCheckFindings: [
        {
          CheckId: "GDTY-01",
          CheckName:
            "Administration of GuardDuty must be delegated to the Audit account for all of the Control Tower managed regions.",
          Finding: "Delegated Administrator access is not enabled",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-03",
          CheckName:
            "GuardDuty Admin accounts from all controltower managed regions should have all ControlTower managed accounts added as a member",
          Finding:
            "GuardDuty Admin account does not have added member accounts that are managed by controltower",
          Status: "Failed",
        },
        {
          CheckId: "GDTY-07",
          CheckName:
            "Guardduty should  not be suspended in controltower managed member accounts in each controltower managed regions",
          Finding: "GuardDuty is suspended",
          Status: "Failed",
        },
      ],
      ServiceCode: "GuardDuty",
      ServiceScanErrorMessage: null,
      ServiceStatus: "NOT_CONFIGURED",
      UpdatedAt: "2023-06-12 14:28:19",
    },
  ];
};

export const setFbpConfiguration = (payload) => {
  const index = fbpManagementAccountDetails.findIndex(
    (data) => data.ServiceCode === payload.ServiceCode
  );

  const shouldAddNotifications = [
    serviceIds.SecurityHub,
    serviceIds.GuardDuty,
  ].includes(payload.ServiceCode);

  fbpManagementAccountDetails[index] = {
    ...fbpManagementAccountDetails[index],
    ServiceStatus: CONFIGURED_SERVICE_STATUS,
    ...(shouldAddNotifications ? { Notifications: payload.Notifications } : {}),
  };
  return;
};
